import CommandIntelligenceIcon from '../../../../components/icons/CommandIntelligenceIcon';
import { isIntelligenceApp } from './is-intelligence-app';

/** App refs that render a React icon component instead of a static tray image. */
export const appRefToIconComponentMap = {
  ai: CommandIntelligenceIcon,
  'assistant-exp': CommandIntelligenceIcon,
  'cds-ai-service': CommandIntelligenceIcon,
};

export const resolveAppIconComponent = (appRef, name) => {
  if (appRefToIconComponentMap[appRef]) {
    return appRefToIconComponentMap[appRef];
  }

  if (isIntelligenceApp(appRef, name)) {
    return CommandIntelligenceIcon;
  }

  return null;
};
